import React from 'react';
import { Icon, List, ListItem, ListItemIcon, ListItemText, Divider } from '@material-ui/core';
import Logo from '../../../images/logo.png';
import { Link } from 'react-router-dom';

//css
import './sidebar.css';

export default class Sidebar extends React.Component {
    render() {
		const { menus } = this.props;
        return (
			<div className="sidebar_app" >
				<div className="logo_row" >
					<img src={Logo} alt="" />
				</div>
				<Divider />
				<List component="nav" aria-label="Menu" >
					{menus.map((m,k) => <ListItem key={k} component={Link} to={m.url} button>
						<ListItemIcon>
							<Icon>{m.icon}</Icon>
						</ListItemIcon>
						<ListItemText primary={m.title} />
					</ListItem>)}
				</List>
			</div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/painel/components/Sidebar/index.js